var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgActivate(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.786 0.215383C24.5788 0.00815692 24.2679 -0.0555637 23.9961 0.0532252L0.460913 9.46717C0.191627 9.57489 0.0113046 9.83133 0.000953044 10.1212C-0.00934967 10.4111 0.152369 10.6797 0.413306 10.8062L9.69395 15.3072L14.195 24.5879C14.3178 24.841 14.5741 25.0007 14.8539 25.0007C14.8625 25.0007 14.8713 25.0006 14.88 25.0002C15.1698 24.9899 15.4264 24.8096 15.534 24.5403L24.9481 1.00532C25.0569 0.733253 24.9931 0.42256 24.786 0.215383ZM2.54411 10.2116L21.227 2.73852L10.0928 13.8726L2.54411 10.2116ZM14.7896 22.4571L11.1286 14.9084L22.2628 3.77426L14.7896 22.4571Z",
    fill: "#2A0C66"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgActivate);
export default __webpack_public_path__ + "static/media/activate.2ccd932eca1b15c023ba25f17e397201.svg";
export { ForwardRef as ReactComponent };